<div class="modal active">
  <div class="modal__container" [ngClass]="entity == 'Flight Inspection' || entity == 'Processing Tool'? 'modal__container--sm' : ''">
    <div class="fields">
      <h2>{{ type }}  {{ entity }}</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                  <label *ngIf="type == 'Horizon Tool Select' " class="full">
                    If you wish to center the Horizon on a NavAid, please select the NavAid to use ({{ dataSource?.filteredData.length }} available).
                  </label>
                  <label *ngIf="type == 'Horizon Tool Select' " class="full">To use clicked position press cancel.</label>
                  <label *ngIf="type == 'Terrain Select' " class="full">
                    If you wish to use terrains from other projects, please select the terrains to use ({{ dataSource?.filteredData.length }} available).
                  </label>
                  <label *ngIf="type != 'Horizon Tool Select' && type != 'Terrain Select' " class="full">Select {{ entity }} to {{ type }} ({{ dataSource?.filteredData.length }} available)</label>
                  <div class="filter" *ngIf="selectAllActive">
                    <a (click)="selectAll()" style="cursor: pointer">Select All</a>
                    <a (click)="deselectAll()" style="cursor: pointer">Deselect All</a>
                  </div>
                  <div style="max-height: 350px; overflow-y: scroll;">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
                      <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns; let i = index;">
                        <div *ngIf="column == 'isSelected'">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <input name="isSelected_{{element.id}} " type="checkbox" [checked]="element.isSelected" [disabled]="element.isDefault" [(ngModel)]="element.isSelected" (click)="onLineClick(element);"/>
                          </td>
                        </div>
                        <div *ngIf="column != 'isSelected'">
                          <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                          <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
                        </div>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </div>
        </div>
          </div>
          <div class="fields__btn">
            <button class="blue" (click)="ok();">OK</button>
            <button class="gray"(click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
